import { render, staticRenderFns } from "./CsCheckbox.vue?vue&type=template&id=48d75ea0&"
import script from "./CsCheckbox.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsCheckbox.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports